export default __webpack_public_path__ + "static/media/grafema_severe_05.b78ba674.jpg";